var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, headerAttributes, id, title, validationId) {
      


































pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};































































pug_mixins["switchbox"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["double-label-switch",attributes.containerHtmlClass], [false,false]), false, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes([attributes.labelHtmlClass], [true]), false, true)+pug.attr("for", id, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"switch round large\"\u003E\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+" type=\"checkbox\""+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("id", id, true, true)+pug.attr("name", id, true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-true-value", attributes['ng-true-value'], true, true)+pug.attr("ng-init", attributes['ng-init'], true, true)+pug.attr("ng-false-value", attributes['ng-false-value'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E\u003Clabel" + (" class=\"switch__label\""+pug.attr("for", id, true, true)) + "\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};






































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};





























































pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}
pug_mixins["fieldset"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
fieldsetCounter++;
title = attributes.title || ''
delete attributes.title
headerAttributes = {}
if (!attributes.noCollapse) {
headerAttributes['ng-click'] = 'fieldset'+ fieldsetCounter +'.closed = !fieldset'+ fieldsetCounter +'.closed'
}
if (attributes.closed) {
headerAttributes['ng-init'] = 'fieldset'+ fieldsetCounter +'.closed =' + attributes.closed
delete attributes.closed
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "bigbox"},attributes]), true)) + "\u003E\u003Cdiv" + (pug.attrs(pug.merge([{"class": "header"},headerAttributes]), true)) + "\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
if (!attributes.noCollapse) {
pug_html = pug_html + "\u003Cspan" + (" class=\"openable\""+pug.attr("ng-class", '{selected: !fieldset'+ fieldsetCounter +'.closed}', true, true)) + "\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv" + (" class=\"main\""+pug.attr("ng-hide", 'fieldset'+ fieldsetCounter +'.closed', true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"cockpit_arbeitnmv-wrapper\" overlay=\"cmEdit.loading.search || cmEdit.loading.main\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_mixins["fieldset"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-3\"\u003E";
pug_mixins["input"].call({
attributes: {"data-cy": "vn.administration.pcLeasing.employeeFilters.inputEmployeeId","key": "cmEdit.filters.employee_id","title": "ValueNet ID","attributes": {"ng-model-options":"{ debounce: 1000 }","ng-keyup":"cmEdit.triggerSearch($event)"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "cmEdit.filters.customer_id","title": "Customer ID","attributes": {"ng-model-options":"{ debounce: 1000 }","ng-keyup":"cmEdit.triggerSearch($event)"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "cmEdit.filters.order_id","title": "Auftragsnummer","attributes": {"ng-model-options":"{ debounce: 300 }","ng-keyup":"cmEdit.triggerSearch($event)"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "cmEdit.filters.contract_id","title": "Leasingvertragsnummer","attributes": {"ng-model-options":"{ debounce: 300 }","ng-keyup":"cmEdit.triggerSearch($event)"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-3\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "cmEdit.filters.invoice_reference","title": "Rechnungsnummer","attributes": {"ng-model-options":"{ debounce: 300 }","ng-keyup":"cmEdit.triggerSearch($event)"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3\"\u003E\u003Cdatepicker date-format=\"dd.MM.yyyy\" selector=\"filtersBeginDate\" date-refocus=\"false\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "cmEdit.filters.begin_date","title": "Beginn","attributes": {"autocomplete":"off","vn-date-helper":true,"ng-pattern":"\u002F^(0?[1-9]|[12][0-9]|3[01])\\.([0]?[0-9]|1[0-2])\\.\\d{4}$\u002F","ng-model-options":"{ debounce: 300 }","ng-keyup":"cmEdit.triggerSearch($event)"},"fieldHtmlClass": "filtersBeginDate"}
});
pug_html = pug_html + "\u003C\u002Fdatepicker\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3\"\u003E\u003Cdatepicker date-format=\"dd.MM.yyyy\" selector=\"filtersEndDate\" date-refocus=\"false\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "cmEdit.filters.end_date","title": "Ende","attributes": {"autocomplete":"off","vn-date-helper":true,"ng-pattern":"\u002F^(0?[1-9]|[12][0-9]|3[01])\\.([0]?[0-9]|1[0-2])\\.\\d{4}$\u002F","ng-model-options":"{ debounce: 300 }","ng-keyup":"cmEdit.triggerSearch($event)"},"fieldHtmlClass": "filtersEndDate"}
});
pug_html = pug_html + "\u003C\u002Fdatepicker\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-3\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchIncludeDeleted","key": "cmEdit.filters.with_deleted","title": "gelöschte Warenkörbe anzeigen"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-4 filter-input\"\u003E\u003Cdiv\u003E\u003Clabel class=\"control-label\"\u003EApproval State\u003C\u002Flabel\u003E\u003Cui-select ng-model=\"cmEdit.filters.approval_state.selected\" theme=\"select2\" append-to-body=\"true\" title=\"Approval State Filter\" search-enabled=\"false\" multiple style=\"width:100%;\"\u003E\u003Cui-select-match placeholder=\"Status wählen...\"\u003E{{$item.display}}\u003C\u002Fui-select-match\u003E\u003Cui-select-choices repeat=\"approval_state.id as approval_state in cmEdit.filters.approval_state.options\"\u003E\u003Cspan ng-bind=\"approval_state.display\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fui-select-choices\u003E\u003C\u002Fui-select\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-4 filter-input\"\u003E\u003Cdiv\u003E\u003Clabel class=\"control-label\"\u003EAuftragsstatus\u003C\u002Flabel\u003E\u003Cui-select ng-model=\"cmEdit.filters.order_process_states.selected\" append-to-body=\"true\" theme=\"select2\" title=\"'Order Process states filter\" search-enabled=\"false\" multiple style=\"width:100%\"\u003E\u003Cui-select-match placeholder=\"Status wählen...\"\u003E{{$item.display}}\u003C\u002Fui-select-match\u003E\u003Cui-select-choices repeat=\"orderState.id as orderState in cmEdit.filters.order_process_states.options\"\u003E\u003Cspan ng-bind=\"orderState.display\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fui-select-choices\u003E\u003C\u002Fui-select\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-4 filter-input\"\u003E\u003Cdiv\u003E\u003Clabel class=\"control-label\"\u003EFlags\u003C\u002Flabel\u003E\u003Cui-select ng-model=\"cmEdit.filters.bo_flags_filters.selected\" append-to-body=\"true\" theme=\"select2\" title=\"'BO Flags filter\" search-enabled=\"false\" multiple style=\"width:100%\"\u003E\u003Cui-select-match placeholder=\"Flags wählen...\"\u003E{{$item.display}}\u003C\u002Fui-select-match\u003E\u003Cui-select-choices repeat=\"flag.value as flag in cmEdit.filters.bo_flags_filters.options\"\u003E\u003Cspan ng-bind=\"flag.display\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fui-select-choices\u003E\u003C\u002Fui-select\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-4 filter-input\"\u003E\u003Cdiv\u003E\u003Clabel class=\"control-label\"\u003EPC-Leasing Status\u003C\u002Flabel\u003E\u003Cui-select ng-model=\"cmEdit.filters.component_states.selected\" append-to-body=\"true\" theme=\"select2\" title=\"PC Component States\" search-enabled=\"false\" multiple style=\"width:100%\"\u003E\u003Cui-select-match placeholder=\"Status wählen...\"\u003E{{$item.name}}\u003C\u002Fui-select-match\u003E\u003Cui-select-choices repeat=\"state.id as state in cmEdit.filters.component_states.options\"\u003E\u003Cspan ng-bind=\"state.display\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fui-select-choices\u003E\u003C\u002Fui-select\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-4 filter-input\"\u003E\u003Cdiv\u003E\u003Clabel class=\"control-label\"\u003EWarenkorb-Typ\u003C\u002Flabel\u003E\u003Cui-select ng-model=\"cmEdit.filters.basket_types.selected\" append-to-body=\"true\" theme=\"select2\" title=\"Basket Types\" search-enabled=\"false\" multiple style=\"width:100%\"\u003E\u003Cui-select-match placeholder=\"Typ wählen...\"\u003E{{$item.display}}\u003C\u002Fui-select-match\u003E\u003Cui-select-choices repeat=\"state.id as state in cmEdit.filters.basket_types.options\"\u003E\u003Cspan ng-bind=\"state.display\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fui-select-choices\u003E\u003C\u002Fui-select\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-4 filter-input\"\u003E\u003Cdiv\u003E\u003Clabel class=\"control-label\"\u003EZahlungsstatus\u003C\u002Flabel\u003E\u003Cui-select ng-model=\"cmEdit.filters.billing_states.selected\" append-to-body=\"true\" theme=\"select2\" title=\"Basket Types\" search-enabled=\"false\" multiple style=\"width:100%\"\u003E\u003Cui-select-match placeholder=\"Typ wählen...\"\u003E{{$item.display}}\u003C\u002Fui-select-match\u003E\u003Cui-select-choices repeat=\"state.id as state in cmEdit.filters.billing_states.options\"\u003E\u003Cspan ng-bind=\"state.display\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fui-select-choices\u003E\u003C\u002Fui-select\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-6\" ng-if=\"cmEdit.employeeExists\"\u003E\u003Cbutton class=\"button button-default\" type=\"button\" ng-click=\"cmEdit.openAddBasketDialog($event)\" data-cy=\"vn.administration.pcLeasing.employeeFilters.buttonManualBasket\"\u003EPC Manuell anlegen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-class=\"{'columns': true,  'medium-6': cmEdit.employeeExists, 'medium-12': !cmEdit.employeeExists, 'text-right': true}\"\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"cmEdit.search();\" data-cy=\"vn.administration.pcLeasing.employeeFilters.buttonSearch\"\u003ESuchen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"title": "{{numberOfBaskets}} Warenkörbe gefunden. Bitte mindestens einen Filter angeben"}
});
pug_mixins["fieldset"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"mpp_basket_list_container\"\u003E\u003Cdiv class=\"list-box__row bigbox\" ng-repeat=\"basket in employee.baskets\" ng-class=\"{'toggable-content-open': basket.toggleContentShowable }\" toggable-content=\"basket.toggleContentShowable\" data-cy=\"vn.administration.pcLeasing.{{employee.id}}-{{basket.id || basket._id}}.toggleBasket\"\u003E\u003Ctoggable-content-toggler ng-init=\"basket.toggleContentShowable\"\u003E\u003Cdiv class=\"list-box__item\"\u003E\u003Cspan class=\"list-box__itemTitle\" ng-click=\"togglerClicked()\"\u003E\u003Cdiv class=\"header\" ng-style=\"{ 'backgroundColor' : (basket.state == 'deleted') ? 'red' : 'inherit' }\"\u003E\u003Cspan ng-if=\"basket.last_checkout_date\" data-cy=\"vn.administration.pcLeasing.{{employee.id}}-{{basket.id || basket._id}}.textOrderState\"\u003EWarenkorb vom {{ formatDate(basket.last_checkout_date, true) }} - {{ basket.bonus ? \"Bonus\" : \"Neo\" }} - {{ basket.order_process && cmEdit.getOrderStatusById(basket.order_process.state_id) }}\u003C\u002Fspan\u003E\u003Cspan ng-if=\"!basket.last_checkout_date\"\u003EWarenkorb erstellt am {{ formatDate(basket.created, true) }} - {{ basket.bonus ? \"Bonus\" : \"Neo\" }} - {{ basket.order_process && cmEdit.getOrderStatusById(basket.order_process.state_id) }}\u003C\u002Fspan\u003E\u003C!--span.openable(ng-class=\"{selected: !open}\")--\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-if=\"cmEdit.canAddAOCyberport(basket)\" ng-click=\"cmEdit.openOrderIdForOldBasketsDialog(basket, $event)\"\u003EAU Cyberport\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary\" ng-if=\"basket.order_process &amp;&amp; cmEdit.ORDER_STATUS_BUTTON_CONFIG_BY_ID[basket.order_process.state_id]['to_show']\" ng-click=\"cmEdit.openOrderProcessDialog(basket, $event)\" data-cy=\"vn.administration.pcLeasing.{{employee.id}}-{{basket.id || basket._id}}.buttonOrderProcess\"\u003E{{cmEdit.ORDER_STATUS_BUTTON_CONFIG_BY_ID[basket.order_process.state_id]['button_display']}}\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"cmEdit.openControlDialog(basket, $event)\" ng-if=\"cmEdit.canOpenControlDialog(basket)\" data-cy=\"vn.administration.pcLeasing.{{employee.id}}-{{basket.id || basket._id}}.buttonControlProcess\"\u003EKontrolle\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"cmEdit.openMigrationDialog(basket, $event)\" ng-if=\"cmEdit.canOpenMigrationDialog(basket, employee)\"\u003EMigrate\u003C\u002Fbutton\u003E\u003Cdiv class=\"toggable-state-feedback\" style=\"float: right\"\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"cmEdit.openInvoicePaymentDialog(basket, $event)\" ng-if=\"cmEdit.hasOpenInvoice(basket, employee)\" data-cy=\"vn.administration.pcLeasing.{{employee.id}}-{{basket.id || basket._id}}.buttonPayInvoice\"\u003EPay Invoice\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"list-box__item__content\" toggable-content-content ng-if=\"basket.toggleContentShowable\"\u003E\u003Cdiv class=\"cockpit_toggable-content\"\u003E\u003Cmpp-basket-component basket=\"basket\" on-change=\"cmEdit.handleBasketChange(changeEvent)\"\u003E\u003C\u002Fmpp-basket-component\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftoggable-content-toggler\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"title": "Bestehende Warenkörbe: {{employee.id}}, {{employee.name}}","ng-repeat": "employee in employees | orderBy: basket.state : reverse : false track by $index","overlay": "cmEdit.loading.search || cmEdit.loading.main"}
});
},
attributes: {"class": "form-padding","id": "editForm"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "headerAttributes" in locals_for_with ?
        locals_for_with.headerAttributes :
        typeof headerAttributes !== 'undefined' ? headerAttributes : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "title" in locals_for_with ?
        locals_for_with.title :
        typeof title !== 'undefined' ? title : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;